import { FC } from 'react';
import { Box, Flex, Palette, Text } from '@updater/ui-uds';
import { TvInternetOffer } from '@updater/consumer-graph';
import { useOfferContext } from '@updater/ui-widgets';
import {
  GameController,
  Globe,
  HouseLine,
  Laptop,
  LightbulbFilament,
  Television,
} from '@phosphor-icons/react';

const greatForList = [
  { icon: HouseLine, text: 'Large households (5+ people)' },
  { icon: Television, text: '4K streaming on multiple devices' },
  { icon: GameController, text: 'Online gaming' },
  { icon: Laptop, text: 'Video conferencing' },
  { icon: LightbulbFilament, text: 'Smart home devices' },
];

export const GreatForSection: FC = () => {
  const { products } = useOfferContext() as TvInternetOffer;
  const downloadSpeed = products?.internet?.downloadSpeed?.value ?? 0;

  const items =
    downloadSpeed > 300
      ? greatForList
      : [{ icon: Globe, text: 'Everyday browsing' }];

  return (
    <Box mb="m">
      <Text variant="mBold" mb="s">
        Great for...
      </Text>
      {items.map(({ icon: Icon, text }) => (
        <Flex key={text} alignItems="center" mb="xs" gap="xs">
          <Icon size={22} color={Palette.blue600} />
          <Text variant="s" ml="xxs">
            {text}
          </Text>
        </Flex>
      ))}
    </Box>
  );
};
